import React from 'react'
import Manager from '../../public/components/Manager'
import RequisitionDiv from './RequisitionDiv'
Ext.require('Ext.Toast')

const config = {
    tabs: {
        申请中: {
            buttons: [
                { text: '申请...', handler: ({ showDetail, refreshPage }) => showDetail(props => <RequisitionDiv {...props} id={0} />) },
            ],
            columns: [
                { _text: '请购单号', field: 'Number', minWidth: 150, flex: 1, search: true },
                { _number: '支付金额', field: 'LCTaxAmount', minWidth: 150, flex: 1 },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <RequisitionDiv {...props} id={data.id} onSave={refreshPage} />)
            }
        },
        退回申请: {
            buttons: [
            ],
            columns: [
                { _text: '请购单号', field: 'Number', minWidth: 150, flex: 1, search: true },
                { _number: '支付金额', field: 'LCTaxAmount', minWidth: 150, flex: 1 },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <RequisitionDiv {...props} id={data.id} onSave={refreshPage} />)
            }
        },
        签核中: {
            buttons: [
            ],
            columns: [
                { _text: '请购单号', field: 'Number', minWidth: 150, flex: 1, search: true },
                { _number: '支付金额', field: 'LCTaxAmount', minWidth: 150, flex: 1 },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <RequisitionDiv {...props} id={data.id} onSave={refreshPage} readOnly={true} />)
            }
        },
        已完成: {
            buttons: [
            ],
            columns: [
                { _text: '请购单号', field: 'Number', minWidth: 150, flex: 1, search: true },
                { _number: '支付金额', field: 'LCTaxAmount', minWidth: 150, flex: 1 },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <RequisitionDiv {...props} id={data.id} onSave={refreshPage} />)
            }
        },
    }
}

export default props => <Manager {...props} config={config} />